export default "__VITE_ASSET__XQbamgox__"